<app-subject-form
  [currentAddressFormGroup]="addressFormGroup" [enableIdentificationHeader]="true" [identificationFormGroup]="identificationFormGroup" [subjectFormGroup]="subjectFormGroup"
  (back)="back.emit()" (submittedData)="submittedData.emit($event)" (formSubmitted)="displayErrors = $event">
  <div [formGroup]="identificationFormGroup" [ngClass]="{'ng-invalid-group': identificationFormGroup.errors}">
    <div class="row">
      <div class="form-group col-md-3">
        <label>{{ 'content.last-4-digits-of-sin' | translate }}
          <input appHideOnBlur class="form-control" type="text" autocomplete="on" formControlName="sin" mask="0000" placeholder="" #sinInput>
        </label>
        <app-validation-errors [displayErrors]="displayErrors"
                               [errors]="[identificationFormGroup.errors, identificationFormGroup.controls.sin.errors]"
                               [element]="sinInput"></app-validation-errors>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-3">
        <!-- TODO: (feature) date picker -->
        <label>{{ 'content.person.dob' | translate }}
          <input appHideOnBlur class="form-control" type="text" autocomplete="on" formControlName="dob" mask="0000-00-00" placeholder="yyyy-mm-dd" #dobInput>
        </label>
        <!-- TODO: (feature) validate it's a real date -->
        <app-validation-errors [displayErrors]="displayErrors"
                               [errors]="[identificationFormGroup.errors, identificationFormGroup.controls.dob.errors]"
                               [element]="dobInput"></app-validation-errors>
      </div>
    </div>
  </div>
</app-subject-form>
